import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  IconButton,
  makeStyles,
} from '@material-ui/core'
import {
  Close as CloseIcon,
  ArrowForward as ArrowForwardIcon,
} from '@material-ui/icons'

const STORAGE_KEY = 'wm_classic_version_modal_dismissed'

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 16,
    padding: theme.spacing(1),
    maxWidth: 480,
    width: '100%',
  },
  closeBtn: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
  content: {
    textAlign: 'center',
    padding: theme.spacing(4, 4, 3),
  },
  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 72,
    height: 72,
    borderRadius: '50%',
    backgroundColor: 'rgba(242, 122, 84, 0.12)',
    marginBottom: theme.spacing(2),
    fontSize: 40,
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.3,
  },
  body: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
    lineHeight: 1.6,
  },
  primaryBtn: {
    borderRadius: 8,
    padding: theme.spacing(1.2, 3),
    fontWeight: 600,
    textTransform: 'none',
    fontSize: '1rem',
    marginBottom: theme.spacing(1),
  },
  classicBtn: {
    textTransform: 'none',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
}))

interface Props {
  newAppUrl: string
}

const NewVersionModal: React.FC<Props> = ({ newAppUrl }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setOpen(true)
    }
  }, [])

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1')
    setOpen(false)
  }

  const goNewVersion = () => {
    localStorage.setItem(STORAGE_KEY, '1')
    window.location.href = newAppUrl
  }

  return (
    <Dialog
      open={open}
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: classes.paper }}
    >
      <IconButton className={classes.closeBtn} size="small" onClick={dismiss}>
        <CloseIcon />
      </IconButton>

      <DialogContent className={classes.content}>
        <div className={classes.iconWrapper}>🚀</div>

        <Typography variant="h6" className={classes.title}>
          A new WellManager experience is available
        </Typography>

        <Typography variant="body2" className={classes.body}>
          We&apos;ve redesigned your monitoring dashboard to be faster, clearer,
          and easier to use. You can always come back to the classic version at
          any time.
        </Typography>

        <Button
          fullWidth
          variant="contained"
          color="primary"
          className={classes.primaryBtn}
          endIcon={<ArrowForwardIcon />}
          onClick={goNewVersion}
        >
          Try the new version
        </Button>

        <Button className={classes.classicBtn} onClick={dismiss}>
          ← Stay on classic version
        </Button>
      </DialogContent>
    </Dialog>
  )
}

export default NewVersionModal
